var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Link as MuiLink, Stack, Typography } from '@mui/material';
export var ReviewSectionHeader = function (_a) {
  var label = _a.label,
    onNavigate = _a.onNavigate,
    subtitle = _a.subtitle,
    viewOnly = _a.viewOnly;
  return _jsxs(Stack, __assign({
    spacing: 0.5
  }, {
    children: [_jsx(Typography, __assign({
      variant: "h3"
    }, {
      children: viewOnly ? label : _jsx(MuiLink, __assign({
        component: "button",
        type: "button",
        onClick: onNavigate,
        sx: {
          color: 'inherit',
          textDecoration: 'underline',
          textUnderlineOffset: '0.12em',
          fontWeight: 'inherit',
          fontSize: 'inherit',
          cursor: 'pointer'
        }
      }, {
        children: label
      }))
    })), subtitle && _jsx(Typography, __assign({
      sx: {
        py: 2
      }
    }, {
      children: subtitle
    }))]
  }));
};